const GeoMark = ({ size = 28, className = "", dark = false }) => (
  <img
    src={dark ? "/assets/logo-mark-white.png" : "/assets/logo-mark.png"}
    width={size}
    height={Math.round((size * 290) / 329)}
    alt=""
    aria-hidden="true"
    data-testid="geo-mark"
    className={className}
  />
);

export default GeoMark;
